const Sentry = require("@sentry/nextjs");
const HOMEPAGE_EXACT_AB_TEST_STORAGE_KEY = "homepage_exact_ab_test";
const setHomepageExactAbTest = (variant)=>{
    try {
        localStorage.setItem(HOMEPAGE_EXACT_AB_TEST_STORAGE_KEY, variant);
    } catch (error) {
        Sentry.captureMessage(`Failed to set homepage exact AB test in localStorage : ${error === null || error === void 0 ? void 0 : error.message}`);
    }
};
const clearHomepageExactAbTest = ()=>{
    try {
        localStorage.removeItem(HOMEPAGE_EXACT_AB_TEST_STORAGE_KEY);
    } catch (error) {
        Sentry.captureMessage(`Failed to clear homepage exact AB test in localStorage : ${error === null || error === void 0 ? void 0 : error.message}`);
    }
};
const getHomepageExactAbTest = ()=>localStorage.getItem(HOMEPAGE_EXACT_AB_TEST_STORAGE_KEY);
module.exports = {
    setHomepageExactAbTest,
    clearHomepageExactAbTest,
    getHomepageExactAbTest
};
